import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import PostHeaderIcons from '../../../app/components/post-header-icons';
import AuthorWithPostDetails from '../../../app/components/author-with-post-details';
import Avatar from '../../../app/components/avatar';
import withNavigation from '../../../app/hoc/with-navigation';
import withFeedMetadataSettings from '../../../app/hoc/with-feed-metadata-settings';
import styles from './post-list-item-header.scss';

function PostListItemHeader({
  type,
  post,
  showProfileImage,
  navigation: { ProfileLink },
  isMetadataHeaderVisible,
  showAuthorName,
  showAuthorBadge,
  showPublishDate,
  showReadingTime,
  showAuthorPicture,
}) {
  const className = classNames(styles.container, styles[type], 'blog-post-metadata-font', 'post-header');

  return (
    <div className={className}>
      {isMetadataHeaderVisible && (
        <div className={styles.metadata}>
          {showAuthorName && showProfileImage && showAuthorPicture && (
            <ProfileLink user={post.owner}>
              <Avatar user={post.owner} isNameVisible={false} />
            </ProfileLink>
          )}
          <AuthorWithPostDetails
            post={post}
            type={type}
            showAuthorName={showAuthorName}
            showPublishDate={showPublishDate}
            showReadingTime={showReadingTime}
            showAuthorBadge={showAuthorBadge}
          />
        </div>
      )}
      <PostHeaderIcons post={post} className={styles.icons} iconClassName="blog-button-fill" />
    </div>
  );
}

PostListItemHeader.propTypes = {
  type: PropTypes.string.isRequired,
  post: PropTypes.object,
  showProfileImage: PropTypes.bool,
  navigation: PropTypes.object,
  isMetadataHeaderVisible: PropTypes.bool,
  showAuthorName: PropTypes.bool,
  showAuthorBadge: PropTypes.bool,
  showPublishDate: PropTypes.bool,
  showReadingTime: PropTypes.bool,
  showAuthorPicture: PropTypes.bool,
};

PostListItemHeader.defaultProps = {
  showProfileImage: true,
};

export default flowRight(withNavigation, withFeedMetadataSettings)(PostListItemHeader);
